/* eslint-disable default-case */
import { Ajax, Browser } from '@syncfusion/ej2-base';
import $ from 'jquery';
import * as Loader from "react-loader-spinner";

let axios = require('axios');
let qs = require('qs');


export const APIUrlProd = 'https://sipa.allconsulting.org/new_sipa/api/allc.php';
export const tokenProd = '7b0bbb9a809d223e4ca78962ec495bd4512386da26d41de13ef11aea83b50835';
export const APIMonitorURLSvil = 'http://localhost:3010';
export const APIMonitorURLTest = 'https://apicallertest2.digitalpraesidium.it';
export const APIMonitorURLProd = 'https://apicaller2.digitalpraesidium.it';
export const messaggioNoBackend = 'Attenzione!! Nessuna comunicazione attiva con il backend. Riprovare alcun volte e se il problema persiste, contattare il servizio di supporto Digital Praesidium.'
export const messaggioAPIBackendNonTrovata = 'Attenzione!! Comunicazione attiva con il backend ma API non trovata. Contattare il servizio di supporto Digital Praesidium.';
export const messaggioUtenteNonAutorizzato = 'Attenzione!! Utente non autorizzato alle operazioni del Monitor ACT. Riprovare con un altro utente';
export const compagnieVisualDefault = ['103', '105', '110', '116', '120', '128', '129', '130', '131', '132', '149'];
export const widthScreenResolution = window.screen.width * window.devicePixelRatio;
export const heightScreenResolution = window.screen.height * window.devicePixelRatio;
export const chartWidth = Browser.isDevice ? '92%' : '96%'; //widthScreenResolution > 1900 ?  Browser.userAgent.indexOf('Firefox') > -1 ? '85%' :  '80%' : Browser.userAgent.indexOf('Firefox') > -1 ? '105%' :  '110%'; 
export const chartWidth2 = Browser.isDevice ? '92%' : '96%'; //widthScreenResolution > 1900 ?  Browser.userAgent.indexOf('Firefox') > -1 ? '115%' :  '120%' : Browser.userAgent.indexOf('Firefox') > -1 ? '95%' :  '100%';
export const chartWidth3 = Browser.isDevice ? '92%' : '96%'; //widthScreenResolution > 1900 ?  Browser.userAgent.indexOf('Firefox') > -1 ? '129%' :  '136%' : Browser.userAgent.indexOf('Firefox') > -1 ? '109%' :  '116%';
let chartHeightTemp = Browser.userAgent.indexOf('Firefox') > -1 ? '575' : Browser.userAgent.indexOf('Edg') > -1 ? '580' : Browser.userAgent.indexOf('OPR') > -1 ? '585' : '585';
let chartHeightTemp2 = Browser.userAgent.indexOf('Firefox') > -1 ? '755' : Browser.userAgent.indexOf('Edg') > -1 ? '760' : Browser.userAgent.indexOf('OPR') > -1 ? '760' : '760';
export const chartHeight = (parseInt(chartHeightTemp) - ((1080 - heightScreenResolution) === 0 ? 0 : (1080 - heightScreenResolution) < 0 ? (1080 - heightScreenResolution) : (1080 - heightScreenResolution + 50))).toString(); 
export const chartHeight2 = (parseInt(chartHeightTemp2) - ((1080 - heightScreenResolution) === 0 ? 0 : (1080 - heightScreenResolution) < 0 ? (1080 - heightScreenResolution) : (1080 - heightScreenResolution + 50))).toString();
export const colorsData = [
  { Color: 'AliceBlue', Code: '#F0F8FF' },
  { Color: 'Aqua', Code: '#00FFFF' },
  { Color: 'Aquamarine', Code: '#7FFFD4' },
  { Color: 'Beige', Code: '#F5F5DC' },
  { Color: 'BurlyWood', Code: '#DEB887' },
  { Color: 'Chartreuse', Code: '#7FFF00' },
  { Color: 'Coral', Code: '#FF7F50' },
  { Color: 'Cornsilk', Code: '#FFF8DC' },
  { Color: 'LightSalmon', Code: '#FFA07A' },
  { Color: 'DarkTurquoise', Code: '#00CED1' },
  { Color: 'DodgerBlue', Code: '#1E90FF' },
  { Color: 'Gainsboro', Code: '#DCDCDC' },
  { Color: 'Gold', Code: '#FFD700' },
  { Color: 'GreenYellow', Code: '#ADFF2F' },
  { Color: 'Khaki', Code: '#F0E68C' },
  { Color: 'Lavender', Code: '#E6E6FA' },
  { Color: 'LawnGreen', Code: '#7CFC00' },
  { Color: 'LightBlue', Code: '#ADD8E6' },
  { Color: 'MediumSpringGreen', Code: '#00FA9A' },
  { Color: 'MistyRose', Code: '#FFE4E1' },
  { Color: 'Plum', Code: '#DDA0DD' },
  { Color: 'SandyBrown', Code: '#F4A460' },
  { Color: 'Thistle', Code: '#D8BFD8' },
  { Color: 'Turquoise', Code: '#40E0D0' },
  { Color: 'Yellow', Code: '#FFFF00' },
  { Color: 'Tomato', Code: '#FF745C' },
  { Color: 'Violet', Code: '#EE82EE' },
];

export const loaderSpinners = [<Loader.Audio width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.BallTriangle width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.Bars width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.Blocks width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.Circles width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.CirclesWithBar width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.ColorRing width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.Comment width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, 
                               <Loader.Discuss width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, //<Loader.Dna width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, 
                               <Loader.FallingLines width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.FidgetSpinner width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.Grid width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.InfinitySpin width={250} height={250} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.LineWave width={250} height={250} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.MagnifyingGlass width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, 
                               <Loader.MutatingDots width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.Oval width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, 
                               <Loader.ProgressBar width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.Puff width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.Radio width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.RevolvingDot width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.Rings width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.RotatingLines width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.RotatingSquare width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.RotatingTriangles width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.TailSpin width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.ThreeCircles width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, 
                               <Loader.ThreeDots width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>, <Loader.Triangle width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>,
                               <Loader.Vortex width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}/>, <Loader.Watch width={150} height={150} wrapperStyle={{ justifyContent: 'center' }} color='#133B95'/>];

export async function getRemoteData(url, data, type, header) { //Chiamata con oggetti Syncfusion - Non funziona...dà errore a livello di CORS
  let ajax = new Ajax({
      url: url,
      type: type,       
      mode: false,
      data: data,
      setRequestHeader: header,      
      onFailure: (e) => { return false; }
  });

  const response = await ajax.send();
  let retData = JSON.parse(response);  
  return { response: retData['response'], retData: retData['data'] };
}

export async function getRemoteData2(url, paramData, type, header, cbFunction, async, test) {  //Chiamata Javascript puro XHR - Funziona bene
  let xhr = new XMLHttpRequest();
  xhr.withCredentials = false;
  
  xhr.addEventListener("readystatechange", function() {
    if (this.readyState === 4) {
      if (test) {
        cbFunction(this.responseText);
      }
      else {
        let retData = JSON.parse(this.responseText);
        console.log(this.responseText);
        if (retData['response'].cod === 0)
            cbFunction(retData['data']);
        else 
           console.log(retData['response'].message); 
      }           
    }
  });
  
  xhr.open(type, url);
  xhr.setRequestHeader("Content-Type", header);
  xhr.async = async; 
  
  xhr.send(paramData);  
}

export async function getRemoteData3(url, paramData, type, header, cbFunction, async, test) {  //Chiamata Jquery - Funziona bene
  let settings = {
    "url": url,
    "method": type,
    "timeout": 0,
    "headers": header,
    "data": paramData,
    "async": async
  };

  $.ajax(settings).done((response) => {
    if (test) {
      cbFunction(response);
    }
    else {
      debugger;
      let retData = JSON.parse(response);
      console.log(response);
      if (retData['response'].cod === 0)
          cbFunction(retData['data']);
      else 
        console.log(retData['response'].message);
    }
  }).fail((response) => {
    debugger;
    console.log(response);    
  });    
}

export async function getRemoteData4(url, paramData, type, header, cbFunction, async, test) {  //Chiamata Axios - Funziona bene (speriamo)
  let data = qs.stringify(paramData);
  let config = {
    method: type,
    url: url,
    headers: header,
    data: data
  };
  
  axios(config)
  .then(response => {       
      debugger;     
      if (test) {
        cbFunction(response.data);
      }
      else {
        let retData = response.data;
        console.log(JSON.stringify(response.data));
        if (!isNullEmpty(retData['List']))
            cbFunction(JSON.parse(retData['List']));
        else 
            console.log(retData['response'].message);
      }
  })
  .catch(error => {
    debugger;
    console.log(error);
  }); 
}

export async function callAPI(url, paramData, type, header, headerAuth, cbFunctionOK, cbFunctionKO, async, test) {
  var xhr = new XMLHttpRequest();
  xhr.withCredentials = false;

  xhr.onerror = function(err){
    debugger;
    cbFunctionKO(err);
  };

  xhr.addEventListener("readystatechange", function() {
    if (this.readyState === 4 && this.status === 200) {
      if (test) {
        cbFunctionOK(this.responseText);
      }
      else {
        debugger;
        let retData = isNullEmpty(this.responseText) ? [] : JSON.parse(this.responseText);        
        cbFunctionOK(retData);        
      }           
    }
    else if (this.readyState === 4 && this.status === 404)
        cbFunctionKO(this.responseText + this.statusText);
  });
  
  xhr.open(type, url);
  xhr.setRequestHeader("Content-Type", header);
  xhr.setRequestHeader("Authorization", headerAuth);
  xhr.async = async; 

  if (!isNullEmpty(paramData))
      xhr.send(paramData);  
  else
      xhr.send();
}

export function handleMouseMove(event) {
  var eventDoc, doc, body;

  event = event || window.event; // IE-ism

  // If pageX/Y aren't available and clientX/Y are,
  // calculate pageX/Y - logic taken from jQuery.
  // (This is to support old IE)
  if (event.pageX == null && event.clientX != null) {
      eventDoc = (event.target && event.target.ownerDocument) || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;

      event.pageX = event.clientX +
        (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
        (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = event.clientY +
        (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
        (doc && doc.clientTop  || body && body.clientTop  || 0 );
  }

  //console.log ('X: ' + event.pageX + ' - Y:' + event.pageY);

  //if (document.getElementById('TabMonitor').ej2_instances[0].selected<Index === 0 && event.pageX >= 680 && event.pageX <= 735 && event.pageY >= 620 && event.pageY <= 635) 
}

export function leapYear(year)
{
  return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}

export function isNullEmpty(valore, multiArray) {
  try {
      if (multiArray) {
          var _wRet = false;
          for (var i = 0; i < valore.length; i++) {
              if (isNullEmpty(valore[i])) {
                  _wRet = true;
                  break;
              }
          }
          return _wRet;
      } else {
          switch (true) {
              case valore === null:
                  return true;
              case Object.prototype.toString.call(valore) === '[object Date]':
                  return false;
              case typeof valore === 'undefined':
              case typeof valore === 'null':
                  return true
              case typeof valore === 'string':
                  if (valore.toString().trim() == "null" || valore.toString().trim() == "undefined") {
                      return true;
                  } else if (valore.toString().trim().length > 0) {
                      return false;
                  } else {
                      return true;
                  }
              case typeof valore === 'boolean':
                  return false;
              case typeof valore === 'number':
                  return false;
              case typeof valore === 'object':
                  if (Object.keys(valore).length > 0) {
                      return false;
                  } else {
                      return true;
                  }
          }
      }
  }
  catch (ex) {
      return true;
  }
}

export function setInterval_ (fn, delay) {
  var maxDelay = Math.pow(2,31)-1;

  if (delay > maxDelay) {
      var args = arguments;
      args[1] -= maxDelay;

      return setInterval(function () {
        setInterval_.apply(undefined, args);
      }, maxDelay);
  }

  return setInterval.apply(undefined, arguments);
}

export function getSaturdaysAndSundays() {
  var d = new Date();
  var getTot = daysInMonth(d.getMonth(),d.getFullYear()); //Get total days in a month
  var sat = [];   //Declaring array for inserting Saturdays
  var sun = [];   //Declaring array for inserting Sundays

  for(var i=1;i<=getTot;i++){    //looping through days in month
      var newDate = new Date(d.getFullYear(),d.getMonth(),i)
      if(newDate.getDay()===0){   //if Sunday
          sun.push(i);
      }
      if(newDate.getDay()===6){   //if Saturday
          sat.push(i);
      }

  }
  return [sat, sun];
}

function daysInMonth(month,year) {
    return new Date(year, month, 0).getDate();
}
